import api from './api';

export const settingsService = {
    // The university-wide student-employment rules, with each program's two
    // limits under `programLimits`. Any signed-in user may read them.
    async getStudentEmploymentRules() {
        const response = await api.get('/settings/student-employment');
        return response.data;
    },

    // Admin only. `rules` holds the six university-wide values. The answer
    // has the same shape getStudentEmploymentRules returns.
    async updateStudentEmploymentRules(rules) {
        const response = await api.put('/settings/student-employment', rules);
        return response.data;
    },

    // The campus tutoring page students are pointed to ({ url }, url null
    // when none is set). Any signed-in user may read it.
    async getTutoringPage() {
        const response = await api.get('/settings/tutoring-page');
        return response.data;
    },

    // Admin only. An empty `url` clears the page.
    async updateTutoringPage(url) {
        const response = await api.put('/settings/tutoring-page', { url });
        return response.data;
    },
};

export default settingsService;
